if (!window.marikaCountUpInit) {
  window.marikaCountUpInit = true;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseTarget(el) {
    const raw = el.dataset.marikaCountTarget || el.textContent;
    const digits = raw.replace(/[^0-9]/g, '');
    return { value: parseInt(digits, 10) || 0, prefix: '', suffix: raw.replace(/^[0-9,]*/, '') };
  }

  function animateCount(el) {
    const { value, suffix } = parseTarget(el);
    if (prefersReducedMotion || !value) {
      el.textContent = value.toLocaleString() + suffix;
      return;
    }

    const duration = 1600;
    const start = performance.now();

    function tick(now) {
      const progress = Math.min((now - start) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(value * eased);
      el.textContent = current.toLocaleString() + suffix;
      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }

  function init() {
    const elements = document.querySelectorAll('.marika-count-up');
    if (!elements.length) return;

    if (!('IntersectionObserver' in window)) {
      elements.forEach(animateCount);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.4 }
    );

    elements.forEach((el) => observer.observe(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}
